import { ESportsApiV1 } from '@/app/models/sports.model';
import { SportsService } from '@/app/services/sport.service';
import { TranslationService } from '@/app/services/translation.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private translationService = inject(TranslationService);
  private sportsService = inject(SportsService);

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;
    const lang = this.translationService.getLangLocalStorage();

    const sport = lang === 'es' ? 'futbol' : 'football';

    this.sportsService.setSelectedSport(ESportsApiV1.FOOTBALL);

    this.router.navigate([sport], {
      queryParams,
      replaceUrl: true,
      queryParamsHandling: 'preserve',
    });
  }
}
